"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));

var _icons = require("../../toolkit/icons");

//
//  src/button/PlusMinusButton.tsx
//  Project-Lego
//
//  Created by James Long on 11/27/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  onPlus: {
    required: false,
    type: "() => void",
    description: "Optional callback for plus button click"
  },
  onMinus: {
    required: false,
    type: "() => void",
    description: "Optional callback for minus button click"
  }
};
var demoProps = {
  onPlus: function onPlus() {},
  onMinus: function onMinus() {}
};
var discussion = "\n  This component wraps [`IconButton`](/lego/component/IconButton).\n";

var PlusMinusButton = function PlusMinusButton(props) {
  var onPlus = props.onPlus,
      onMinus = props.onMinus;
  return /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: _icons.add,
    onClick: onPlus
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: _icons.remove,
    onClick: onMinus
  }));
};

PlusMinusButton.propDoc = propDoc;
PlusMinusButton.demoProps = demoProps;
PlusMinusButton.discussion = discussion;
var _default = PlusMinusButton;
exports["default"] = _default;